//edit paid client
import {
  PaymentEditQuery,
  Payment_logQuery,
  PaymentUpdateMutation,
} from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import get from 'lodash/fp/get'
import PaymentForm from './PaymentForm'

const paymentQueryConfig = {
  // console.log("hello");
  options: props => ({
    variables: {
      id: get('match.params.id', props),
    },
  }),
  props: ({ data }) => {
    return {
      company: get('viewer.Payment_editQuery.edges', data),
      isEdit: true,
    }
  },
}
console.log("paymentQueryConfig........",paymentQueryConfig);
const paymentUpdateConfig = {
  props: ({ mutate, ownProps }) => {
    console.log("................ownprops.................",ownProps)
    return {
      mutate: values => {
        return mutate({
          variables: {
            id: get('match.params.id', ownProps),
            ...values,
          },
          refetchQueries: [
            {
              query: gql(Payment_logQuery),
            },
          ],
        })
      },
    }
  },
}
console.log("paymentUpdateConfig........",paymentUpdateConfig);
export default compose(
  graphql(gql(PaymentEditQuery), paymentQueryConfig),
  graphql(gql(PaymentUpdateMutation), paymentUpdateConfig)
)(PaymentForm)
